const getters = {
  getLevels: (state) => state.levels,
  getLevel: (state) => state.level,
};

export default getters;
